import { render, staticRenderFns } from "./ShareComponent.vue?vue&type=template&id=955137ee&scoped=true&"
import script from "./ShareComponent.vue?vue&type=script&lang=js&"
export * from "./ShareComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShareComponent.vue?vue&type=style&index=0&id=955137ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955137ee",
  null
  
)

export default component.exports